@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'administration.service.settings' | translate }}</h2>
</div>

<div>
	<form class="flex flex-dir-col mw-400 pt-16 gap-8" (ngSubmit)="save()" #accountForm="ngForm">
		<mat-form-field appearance="outline" class="dialog">
			<mat-label>{{ 'administration.service.accountname' | translate }}</mat-label>
			<input matInput name="accountName" [(ngModel)]="accountName" [disabled]="inputsReadOnly" [attr.tabindex]="inputsReadOnly ? -1 : null" placeholder="'administration.service.accountname' | translate" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label>{{ 'administration.service.allowedIps' | translate }}</mat-label>
			<input matInput name="allowedIps" [(ngModel)]="allowedIpsString" [disabled]="inputsReadOnly" [attr.tabindex]="inputsReadOnly ? -1 : null" placeholder="192.168.0.1, 10.0.0.1" />
		</mat-form-field>
		@if (attemptedSave && !allowedIpsValid) {
			<div class="mat-error ip-error">
				{{ 'administration.service.allowedIpsInvalid' | translate }}
				@if (invalidIps.length) {
					<span>: {{ invalidIps.join(', ') }}</span>
				}
			</div>
		}

		<div class="form-actions form-actions--gap">
			<button
				mat-stroked-button
				type="button"
				(click)="cancel()"
				[disabled]="inputsReadOnly || !hasChanges() || isLoading"
				[ngClass]="{
					'button-border-color': hasChanges() && !isLoading && !inputsReadOnly,
				}">
				{{ 'administration.service.btnCancel' | translate }}
			</button>
			<button mat-flat-button color="primary" type="submit" [disabled]="inputsReadOnly || !hasChanges() || isLoading">
				{{ 'administration.service.btnSave' | translate }}
			</button>
		</div>
	</form>
</div>
